import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LinearProgress } from '@mui/material';

import { IItem } from 'api/catalog/models';
import { CatalogService } from 'api/catalog/services';
import ItemDetails from 'ui/ItemDetails';
import NoResults from 'ui/ErrorDisplay/NoResults';
import ServiceError from 'ui/ErrorDisplay/ServiceError';
import PageWrapper from 'ui/PageWrapper';

const PageProductId = () => {
  const { productId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [item, setItem] = useState<IItem>();
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (productId !== undefined) {
      setIsError(false);
      setIsLoading(true);
      CatalogService.getItemDetails(productId)
        .then((res) => {
          setItem(res.data);
        })
        .catch((isError) => {
          setIsError(true);
          console.warn('isError: ', isError);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [productId]);

  return (
    <PageWrapper>
      {isError ? (
        <ServiceError />
      ) : isLoading ? (
        <LinearProgress />
      ) : !item ? (
        <NoResults />
      ) : (
        <ItemDetails item={item} />
      )}
    </PageWrapper>
  );
};

export default PageProductId;
